import { render, staticRenderFns } from "./sh_DownloadApk.vue?vue&type=template&id=5be12f1e&scoped=true&"
import script from "./sh_DownloadApk.vue?vue&type=script&lang=js&"
export * from "./sh_DownloadApk.vue?vue&type=script&lang=js&"
import style0 from "./sh_DownloadApk.vue?vue&type=style&index=0&id=5be12f1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be12f1e",
  null
  
)

export default component.exports